import { colors } from "@/styles/colors"
import { makeStyles } from "@material-ui/core"

const SIDEBAR_DIVIDER_HORIZONTAL_MARGIN_IN_PIXELS = 16
const SIDEBAR_DIVIDER_TOP_MARGIN_IN_PIXELS = 24

const useStyles = makeStyles({
	divider: {
		marginLeft: SIDEBAR_DIVIDER_HORIZONTAL_MARGIN_IN_PIXELS,
		marginRight: SIDEBAR_DIVIDER_HORIZONTAL_MARGIN_IN_PIXELS,
		marginTop: SIDEBAR_DIVIDER_TOP_MARGIN_IN_PIXELS
	},
	logo: {
		maxWidth: "100px",
		width: "100%",
		height: "auto"
	},
	collapsedLogo: {
		width: 28,
		height: "auto"
	},
	icon: {},
	iconActive: {
		color: colors.purple[500]
	}
})

export default useStyles
